module.exports = __webpack_public_path__ + "img/plus-circle-pink.78e7edbe.svg";